<template>
  <!-- Authors Table Card -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: 0 }"
  >
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">菜单管理·数据表格</h5>
        </a-col>
      </a-row>
    </template>
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form
          layout="inline"
          :form="dataForm"
          @submit="getDataList"
          class="ml-20"
        >
          <a-form-item>
            <a-button type="primary" @click="getDataList">刷新数据</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()"
              >新增菜单</a-button
            >
          </a-form-item>
        </a-form>

        <a-table
          :columns="columns"
          :data-source="dataList"
          :pagination="false"
          rowKey="id"
          defaultExpandAllRows
          :loading="dataListLoading"
          :scroll="{ x: 1500 }"
        >
          <template slot="type" slot-scope="type">
            <a-tag :color="type == 1 ? 'blue' : 'green'">{{
              type == 1 ? "菜单" : "按钮"
            }}</a-tag>
          </template>

          <template slot="hiden" slot-scope="hiden">
            <a-tag :color="hiden == 0 ? 'green' : 'red'">{{
              hiden == 0 ? "显示" : "隐藏"
            }}</a-tag>
          </template>

          <template slot="keepalive" slot-scope="keepalive">
            <a-tag :color="keepalive == 0 ? 'green' : 'red'">{{
              keepalive == 0 ? "不缓存" : "缓存"
            }}</a-tag>
          </template>

          <template slot="editBtn" slot-scope="text, row">
            <a-button
              type="link"
              class="btn-edit"
              @click="addOrUpdateHandle(row.id)"
            >
              编辑
            </a-button>
            <a-button
              type="link"
              class="btn-edit"
              @click="deleteHandle(row.id)"
            >
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>
  
  <script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListIsPage: false,
        getDataListURL: "/admin/menu/page",
        deleteURL: "/admin/menu/delete",
      },
      dataForm: {},
      columns: [
        {
          title: "菜单名称",
          dataIndex: "title",
          width: 200
        },
        {
          title: "页面命名",
          dataIndex: "name",
        },
        {
          title: "图标",
          dataIndex: "icon",
        },
        {
          title: "路由",
          dataIndex: "path",
        },
        {
          title: "组件路径",
          dataIndex: "component",
          class: "text-muted",
        },
        {
          title: '权限',
          dataIndex: 'power'
        },
        {
          title: "类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
          width: 200,
          // fixed: 'right'
        },
        {
          title: "排序",
          dataIndex: "sort",
        },
        {
          title: "是否隐藏",
          dataIndex: "hiden",
          scopedSlots: { customRender: "hiden" },
        },
        {
          title: "是否缓存",
          dataIndex: "keepalive",
          scopedSlots: { customRender: "keepalive" },
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
};
</script>